import { UserService } from '@user/user.service';
import { ExceptionService } from './../../exceptions.service';
import { HttpErrorResponse } from '@angular/common/http';
import { IWorkbook, IErrorResponse, IUser } from '@interfaces';
import { Component, OnInit, Inject, OnDestroy} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { WorkbookService } from '@base/workbook/workbook.service';
import { Subscription } from 'rxjs';
import * as fromUtils from '@utils';

interface IView {
  id: string;
  name: string;
  contentUrl: string;
  createdAt: string;
  updatedAt: string;
  tags: object;
}
@Component({
  selector: 'app-tableau-views-dialog',
  templateUrl: './tableau-views-dialog.component.html',
  styleUrls: ['./tableau-views-dialog.component.sass']
})

export class ViewsDialogComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[];
  views: IView[];
  gettingViews: boolean;
  generatingUrl: boolean;
  workbook: IWorkbook;
  user: IUser;

  constructor(
    public dialogRef: MatDialogRef<ViewsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: object,
    private workbookService: WorkbookService,
    private exceptionService: ExceptionService,
    private userService: UserService,
  ) {
    this.views = [];
    this.subscriptions = [];
    this.gettingViews = true;
    this.generatingUrl = false;
    this.workbook = data['workbook'];
    this.user = data['user'];

    const wbId = fromUtils.getReferencedValue(this.workbook, 'id');
    const vSubscription = this.workbookService.getViews(wbId).subscribe(
      (views: IView[]) => {
        this.views = views;
        this.gettingViews = false;
      },
      (e: HttpErrorResponse) => {const error: IErrorResponse = this.exceptionService.errorHandling(e); }
    );

    this.subscriptions = [...this.subscriptions, vSubscription];
  }

  ngOnInit() {
    //
  }

  ngOnDestroy() {
    this.subscriptions.map((s: Subscription) => s.unsubscribe());
  }

  selectView(view: IView) {
    this.generatingUrl = true;
    const arrayParams = view.contentUrl.split('/');
    const viewName = arrayParams.pop();

    const ticket = this.userService.getTableauParams(this.user).subscribe(
      t => {
        this.generatingUrl = false;

        if (parseInt(t['ticket'], 10) !== -1) {
          let targetUrl = `${t['host']}/trusted/${t['ticket']}/views/${this.workbook['content_url']}`;
          targetUrl += `/${viewName}?:embed=yes&:tabs=yes&:device=desktop&:toolbar=top`;
          this.dialogRef.close(targetUrl);
        } else if (t['ticket'] !== -1) {
          console.log('NO SE GENERO');
        }
      },
      (err: HttpErrorResponse) => { const error: IErrorResponse = this.exceptionService.errorHandling(err); }
    );
  }
}
